<template>
  <v-card
      class="py-0 pl-2"
  >
    <div class="d-flex flex-no-wrap justify-space-between align-center">

      <div>
        <v-avatar tile size="50px">
          <v-img :src="product.image"></v-img>
        </v-avatar>
      </div>

      <div class="title text-left flex-grow-1 pl-3">
        <v-clamp autoresize :max-lines="1">
          {{ product.name.charAt(0).toUpperCase() + product.name.toLowerCase().substring(1) }}
        </v-clamp>
      </div>

      <div>
        <v-card-actions>
          <v-text-field
              v-if="!readonly"
              dense
              single-line
              hide-details
              type="number"
              class="centered-input text-center mr-1"
              v-model.number="quantity"
              :style="{width: '54px'}"
              :append-icon="null"
              min="0"
              :rules="validateStock ? inStockRule : []"
          >
          </v-text-field>
          <v-chip
              v-if="inStock != null"
              class="font-weight-bold"
              :class="minimum >=  inStock ? 'red white--text' : 'primary onPrimary--text'"
          >
            {{ inStock }}
          </v-chip>
        </v-card-actions>
      </div>
    </div>
  </v-card>
</template>

<script>
import VClamp from 'vue-clamp'

export default {
  name: "ProductStock",
  components: {VClamp},
  props: {
    product: Object,
    value: {type: Number, default: 0},
    inStock: {type: Number, default: null},
    minimum: {type: Number, default: 10},
    readonly: {type: Boolean, default: false},
    validateStock: {type: Boolean, default: false}
  },
  computed: {
    quantity: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    inStockRule() {
      return [
        v => (v <= this.inStock) || "Max"
      ]
    }
  },
}
</script>

<style scoped>

</style>
